export default "__VITE_ASSET__DKyBNnCw__"